import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Communication Module Service Stores
 */
export const communicationStores: ServiceStoreConfig[] = [
  {
    name: "support-ticket",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.supportTicketStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalTickets = entities.length;
          const openTickets = entities.filter(
            (ticket: Record<string, unknown>) =>
              ticket.status === "open" || ticket.status === "in_progress"
          ).length;
          const resolvedTickets = entities.filter(
            (ticket: Record<string, unknown>) => ticket.status === "resolved"
          ).length;
          const highPriorityTickets = entities.filter(
            (ticket: Record<string, unknown>) => ticket.priority === "high" || ticket.priority === "critical"
          ).length;

          return [
            {
              title: "Total Tickets",
              value: () => totalTickets.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Open",
              value: () => openTickets.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Resolved",
              value: () => resolvedTickets.toString(),
              valueColor: "success.main",
            },
            {
              title: "High Priority",
              value: () => highPriorityTickets.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "email-history",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "comments",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  // Chat and messaging services
  {
    name: "chat",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "chat-messages",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "conversation-threads",
    options: {
      enableStorage: false,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  // New backend services
  {
    name: "rfi",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "rfi-attachments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "engineering-submittals",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "submittal-documents",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
];